export enum MessagePlatform{
    RealtimeMarketing = 'RealtimeMarketing',
    OutboundMarketing = 'OutboundMarketing',
    Optimizely = 'Optimizely'
}